<template>
  <div>
     <a-card :title="`Rooms of ${application.ew_app_name}`" :bordered="false">
        <a-button type="primary" size="small" slot="extra" @click="addNewHost()">Add</a-button>
        <table class="table table-hover" v-if="application.hosts.length">
            <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Actions</th>
            </tr>
            <tr v-for="(item,i) in application.active_hosts" :key="i">
                <td>{{item.room_name}}</td>
                <td>{{item.type == 1? 'Basic' : item.type == 2 ? 'Licensed':''}}</td>
                <td>
                    <a-popconfirm
                        title="Are you sure delete this host?"
                        ok-text="Yes"
                        cancel-text="No"
                        @confirm="deleteHost(item.room_id)"
                        @cancel="cancel"
                    >
                        <a-button type="danger" title="Delete!" size="small">
                            <span class="ti-trash"></span>
                        </a-button>
                    </a-popconfirm> | 
                    <a-popconfirm
                        title="Are you sure remove this host?"
                        ok-text="Yes"
                        cancel-text="No"
                        @confirm="RemoveHost(item.room_id)"
                        @cancel="cancel"
                    >
                        <a-button type="warning" title="Remove!" size="small">
                            <span class="ti-archive"></span>
                        </a-button>
                    </a-popconfirm>
                </td>
            </tr>
        </table>
    <a-empty v-else>  <span slot="description">No Hosts! </span></a-empty>
    </a-card>
  </div>
</template>
<script>
//large meeting//webinar
import API from '../../../services/api';

export default {
  props:['application','addNewHost','deleteHost','RemoveHost'],
  data(){
      return {

      }
  },
  computed: {
    userLogin() {
      return this.$store.state.auth.user;
    }
  },
  created(){
  },
  methods: {
    goBack(){
      return this.$router.go(-1)
    },
    cancel(){
      
    }
  }
};
</script>
<style>
</style>
